import * as Sentry from "@sentry/react";

function getEnvString(value: unknown, fallback: string): string {
  if (typeof value === "string" && value !== "") {
    return value;
  }

  return fallback;
}

function toSampleRate(value: number, fallback: number): number {
  if (Number.isNaN(value)) {
    return fallback;
  }

  return value;
}

function toOptionalRelease(value: string | undefined): string | undefined {
  if (value === undefined || value === "") {
    return undefined;
  }

  return value;
}

function toTracePropagationTargets(values: string[]): string[] | undefined {
  if (values.length === 0) {
    return undefined;
  }

  return values;
}

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = getEnvString(
  import.meta.env.VITE_SENTRY_ENVIRONMENT,
  import.meta.env.MODE,
);
const tracesSampleRate = parseFloat(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0",
);
const replaysSessionSampleRate = parseFloat(
  import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? "0",
);
const replaysOnErrorSampleRate = parseFloat(
  import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? "1",
);
const release = import.meta.env.VITE_SENTRY_RELEASE?.trim();
const tracePropagationTargets = (
  import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS ?? ""
)
  .split(",")
  .map((value) => value.trim())
  .filter((value) => value !== "");
const integrations: Parameters<typeof Sentry.init>[0]["integrations"] = [];

if (tracesSampleRate > 0) {
  integrations.push(Sentry.browserTracingIntegration());
}

Sentry.init({
  dsn,
  enabled: dsn !== undefined && dsn !== "",
  environment,
  release: toOptionalRelease(release),
  integrations,
  tracesSampleRate: toSampleRate(tracesSampleRate, 0),
  tracePropagationTargets: toTracePropagationTargets(tracePropagationTargets),
  replaysSessionSampleRate: toSampleRate(replaysSessionSampleRate, 0),
  replaysOnErrorSampleRate: toSampleRate(replaysOnErrorSampleRate, 1),
});

// Keep recording code out of the startup bundle and avoid fetching it when
// monitoring is disabled. Errors are still captured by the synchronous SDK.
if (
  dsn !== undefined &&
  dsn !== "" &&
  (replaysSessionSampleRate > 0 || replaysOnErrorSampleRate > 0)
) {
  void import("./sentry-replay")
    .then(({ enableReplay }) => enableReplay())
    .catch((error: unknown) => {
      console.warn("[sentry] Failed to load session replay", error);
    });
}
